/// <reference types="vite-plugin-pwa/client" />
import { registerSW } from 'virtual:pwa-register';
import { useEffect, useState } from 'react';

export function useSW() {
  const [offlineReady, setOfflineReady] = useState(false);
  const [needRefresh, setNeedRefresh] = useState(false);
  const [updateServiceWorker, setUpdateServiceWorker] = useState<() => void>(
    () => () => {},
  );

  useEffect(() => {
    const updateSW = registerSW({
      onOfflineReady() {
        setOfflineReady(true);
      },
      onNeedRefresh() {
        console.log('onNeedRefresh');
        setNeedRefresh(true);
      },
    });
    setUpdateServiceWorker(() => () => {
      console.log('updateServiceWorker');
      void updateSW(true);
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        console.log('controllerchange');
        window.location.reload();
      });
    });
  }, []);

  return {
    offlineReady,
    needRefresh,
    updateServiceWorker,
  };
}
